module.exports = __webpack_public_path__ + "static/img/1_4.541604e1.png";